_ = require 'underscore'
React = require 'react'
moment = require 'moment'
t = require('views/internal/recup-with-helpers')('calendar')
BigCalendar = require '@atlassian/react-big-calendar'
withDragAndDrop = require '@atlassian/react-big-calendar/lib/addons/dragAndDrop'
ModelCache = require 'db/model-cache'
CardPreview = require './calendar-card-preview'
CardEvent = require './calendar-card-event'
CalendarCardComposerView = require 'views/card-composer/calendar-card-composer-view'
PopOver = require 'views/lib/pop-over'
Controller = require 'controller'
Dates = require 'lib/dates'
Util = require 'lib/util'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

BigCalendar.momentLocalizer(moment)
DragAndDropCalendar = withDragAndDrop(BigCalendar, { backend: false })

module.exports = class CalendarPageComponent extends React.Component
  displayName: 'Calendar Page'
  defaultView: 'month'

  constructor: (props) ->
    super(props)
    @state =
      events: @getEvents()
      today: moment()
      selectedDate: props.initialDate
      isCardPreviewOn: false
      cardBeingPreviewed: null
      isShowMoreActive: false
      isHidingOverlay: false
      cardBeingPreviewedCoords:
        top: 0
        bottom: 0
        left: 0
        right: 0

    @debouncedUpdateEvents = _.debounce @updateEvents, 1000, true
    listener = @listenToListChanges.bind(@)
    props.model.listList.each listener
    props.listenTo props.model.listList, 'add remove', (list) =>
      # Don't bind a new listener if event is of type 'changed:closed'
      if _.isEmpty(list.changed)
        listener(list)

    props.listenTo props.model.filter, 'change', @updateEvents.bind(@)

    props.listenTo props.model.boardPluginList, 'add remove', (plugin) =>
      if plugin.get('idPlugin') == CUSTOM_FIELDS_ID
        @debouncedUpdateEvents()
    props.listenTo props.model.customFieldList, 'remove change', (field) =>
      if field.get('type') == 'date'
        @debouncedUpdateEvents()
    props.listenTo ModelCache, 'change:CustomFieldItem add:CustomFieldItem', (item) =>
      # only card about date field items on the current board
      if item.getCard()?.getBoard() == props.model && item.getCustomField()?.get('type') == 'date'
        # we defer to ensure the card's customfielditems are synced first
        _.defer(@debouncedUpdateEvents)

    @updateRoute @state.selectedDate

    if moment(props.initialDate).isSame(moment(), 'day')
      @initialView = @props.localState.getMode()
    else
      @initialView = @defaultView
    @debouncedOnWheel = _.debounce(@onWheel, 40, true)

  cancelCardPreviewLeaveTimer: ->
    clearTimeout @cardPreviewMouseLeaveTimer

  cardToEvent: (card, customFieldItem) ->
    date = customFieldItem?.getParsedValue() || new Date(card.get('due'))
    c = card.toJSON()
    id: c.id || card.cid
    title: c.name
    desc: c.desc
    allDay: false
    start: date
    end: moment(date).add(1, 'hour').toDate()
    dueComplete: c.dueComplete || false
    card: card
    badge: customFieldItem?.getCustomField()?.get('name')
    customFieldItem: customFieldItem
    onMouseEnter: @onMouseEnter
    onMouseLeave: @onMouseLeave

  eventsForCard: (card) ->
    events = []
    card.getDates().forEach (cfi) =>
      events.push(@cardToEvent(card, cfi))
    if card.get('due')?
      events.push(@cardToEvent(card))
    events

  componentDidMount: ->
    updateCurrentDttm = =>
      @todayUpdater = setTimeout =>
        @setState
          today: moment()
        updateCurrentDttm()
      , moment.duration(moment().add(1, 'days').startOf('day').diff(moment())).asMilliseconds()
    updateCurrentDttm()

  componentWillUnmount: ->
    clearTimeout @todayUpdater
    @props.stopListening()

  getCalendarComponent: ->
    if @props.model.editable()
      DragAndDropCalendar
    else
      BigCalendar

  getEvents: ->
    cards = @props.model.openCards()
    events = _.chain(cards)
      .map (card) =>
        if !@props.model.filter.satisfiesFilter(card)
          return []
        @eventsForCard(card)
      .flatten()
      .compact()
      .value()

    events

  hidePreview: ->
    @setState
      isCardPreviewOn: false
      cardBeingPreviewed: null
      cardPreviewMouseLeaveTimer: null

  listenToListChanges: (list) ->
    @props.listenTo list.cardList, 'add', (card) =>
      @setState
        events: @state.events.concat @eventsForCard(card)
      if !card.id
        card.waitForId card, =>
          @setState
            events: @getEvents()

    @props.listenTo list.cardList, 'remove', @debouncedUpdateEvents
    @props.listenTo list.cardList, 'change', @debouncedUpdateEvents
    @props.listenTo list, 'change:closed', @debouncedUpdateEvents

  onBCEventDrop: ({ event, start, end }) ->
    if event.customFieldItem?
      event.customFieldItem.setValue({ date: start.toISOString() })
    else
      event.card.update 'due', start.getTime()

  onBCHideOverlay: =>
    @setState
      isHidingOverlay: true

  onBCNavigate: (newDate, view, action) =>
    newState =
      selectedDate: newDate
    @setState newState
    @updateRoute newDate

  onBCSelectEvent: (event) =>
    @hidePreview()
    Controller.showCardDetail event.card

  onBCSelectSlot: (event) =>
    if @props.model.editable() && !@state.isShowMoreActive
      composer = new CalendarCardComposerView
        model: @props.model.composer
        modelCache: @props.modelCache
        newCalendarEnabled: true
      composer.setDate(new Date(event.start))

      if event.box
        x = event.box.x
        y = event.box.y
      else if event.bounds
        x = event.bounds.x
        y = event.bounds.top

      if x && y
        setTimeout ->
          PopOver.show
            clientx: x
            clienty: y
            view: composer
          , 0
    else
      @setState
        isShowMoreActive: false

  onBCShowMore: =>
    @setState
      isShowMoreActive: true

  onBCView: (view) =>
    @props.localState.setMode(view)

  onMouseEnter: (event, e) =>
    if @state.isHidingOverlay
      @setState
        isHidingOverlay: false
    else
      dim = e.currentTarget.children[0].getBoundingClientRect()
      @cardPreviewMouseEnterTimer = setTimeout =>
        @setState
          isCardPreviewOn: true
          cardBeingPreviewed: event.card
          cardBeingPreviewedCoords: dim
      , 500

  onMouseLeave: (event) =>
    clearTimeout(@cardPreviewMouseEnterTimer)
    @cardPreviewMouseLeaveTimer = setTimeout =>
      @hidePreview()
    , 100

  onWheel: (event) =>
    if @props.localState.getMode() == 'month'
      if !@monthDOM
        @monthDOM = document.querySelector('.rbc-month-view')
      event.persist()
      if event.deltaY > 0 && event.deltaY < 10 &&
        @monthDOM.scrollTop == (@monthDOM.scrollHeight - @monthDOM.offsetHeight)
          newDate = moment(@state.selectedDate).add(1, 'month').startOf('month').toDate()
          setTimeout =>
            @monthDOM.scrollTop = 0 # scroll back to the top
          , 0
      else if event.deltaY < 0 && event.deltaY > -10 && @monthDOM.scrollTop == 0
        newDate = moment(@state.selectedDate).subtract(1, 'month').startOf('month').toDate()
      else
        return
      newState =
        selectedDate: newDate
      @setState newState
      @updateRoute newDate

  updateEvents: =>
    @setState
      events: @getEvents()

  updateRoute: (newDate) ->
    { year, month } = Dates.dateToObj newDate
    month = Util.lpad month, 2, '0'
    Controller.setBoardLocation(
      @props.model.id,
      'calendar',
      [year, month],
      { replace: true }
    )

  render: t.renderable ->
    t.div '.new-calendar-root', {
      onWheel: @debouncedOnWheel
    }, =>
      t.tag CardPreview,
        isCardPreviewOn: @state.isCardPreviewOn
        cardBeingPreviewed: @state.cardBeingPreviewed
        cardBeingPreviewedCoords: @state.cardBeingPreviewedCoords
        hidePreview: @hidePreview.bind @
        cancelCardPreviewLeaveTimer: @cancelCardPreviewLeaveTimer.bind @
        viewMode: @props.localState.getMode()
      t.div '.calendar-header-toolbar-right', =>
        t.a '.icon-lg.icon-gear.dark-hover.js-calendar-settings.nc-settings'
        t.a '.icon-lg.icon-close.dark-hover.js-close-calendar.nc-close-calendar'
      t.div '.new-calendar', =>
        t.div '.nc-main.nc-column', =>
          t.tag @getCalendarComponent(),
            components:
              event: CardEvent
            date: @state.selectedDate
            defaultDate: @state.today.toDate()
            defaultView: @initialView
            events: @state.events
            eventPropGetter: (event) ->
              if event.dueComplete
                className: 'rbc-complete'
              else
                ''
            formats:
              dateFormat: 'D'
              dayFormat: 'D dddd'
              timeGutterFormat: 'ha'
              dayRangeHeaderFormat: ({ start, end }, culture, local) ->
                local.format(start, 'MMMM D', culture) +
                ' - ' +
                local.format(end, (
                  if start.getMonth() == end.getMonth() then 'D' else 'MMMM D'
                ), culture)
              dayHeaderFormat: 'dddd, MMMM D'
            messages:
              date: t.l('date')
              time: t.l('time')
              event: t.l('event')
              allDay: t.l('all_day')
              week: t.l('week')
              work_week: t.l('work_week')
              day: t.l('day')
              month: t.l('month')
              yesterday: t.l('yesterday')
              tomorrow: t.l('tomorrow')
              today: t.l('today')
              agenda: t.l('agenda')
            onEventDrop: @onBCEventDrop
            onNavigate: @onBCNavigate
            onHideOverlay: @onBCHideOverlay
            onSelectEvent: @onBCSelectEvent
            onSelectSlot: @onBCSelectSlot
            onShowMore: @onBCShowMore
            onView: @onBCView
            popup: true
            scrollToTime: moment().hour(8).minute(0).toDate() # expects date object
            selectable: @props.model.editable()
            showMultiDayTimes: true
            step: 30
            tooltipAccessor: ''
            views: ['month', 'week', 'day']



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-page-component.coffee